import { axiosInstance } from "@retro-ia/shared/axios";
import { useQuery } from "@tanstack/react-query";

interface ActividadPrograma {
  id: number;
  nombre: string;
}

export const useActividadesByPrograma = (idPrograma?: number) => {
  return useQuery<ActividadPrograma[], Error>({
    queryKey: ["actividadesByPrograma", idPrograma],
    queryFn: async () => {
      if (!idPrograma) {
        return [];
      }
      const response = await axiosInstance.get(
        `/actividades-programa/programa/${idPrograma}`,
      );
      return response.data;
    },
    enabled: !!idPrograma,
  });
};
